import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/api",
    name: "Home",
    props: true,
    // which is lazy-loaded when the route is visited.
    component: Home,
    children: [
      {
        path: "/api",
        name: "API Documentation List",
        props: true,
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(
            /* webpackChunkName: "about" */ "../components/DocumentList.vue"
          )
      },
      {
        path: "/api/:apiName/documentation",
        name: "Api Documentation",
        props: true,
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../components/ApiDoc.vue")
      }
    ]
  }
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: "history",
  routes
});

export default router;
